import { ca } from '@cian/analytics';

export function trackMortgageWidgetAnchorShow() {
  ca('eventSite', {
    action: 'Show_sopr',
    category: 'card',
    label: 'trapMortgageOfferScreen',
    name: 'oldevent',
    useLastProducts: true,
  });
}

export function trackMortgageWidgetAnchorClick() {
  ca('eventSite', {
    action: 'click_head_price_widget',
    category: 'card',
    label: 'Mortgage_calculators',
    name: 'oldevent',
    useLastProducts: true,
  });
}
